/**
 * Helper pur : derive le statut d'une pill (URSSAF, LIASSE, KBIS, CNI, DEVIS, AH, LIVRE)
 * en fonction du raw status DB et du contexte du dossier.
 *
 * Extrait de DocPills.jsx pour testabilite. Pas de React/JSX.
 *
 * Regles :
 *  - Admin docs (URSSAF/LIASSE/KBIS/CNI) : raw status DB tel quel. Si manquant, on
 *    laisse manquant (le client DOIT envoyer ces docs des l'annonce).
 *  - Generes (DEVIS/AH) : `na` tant que le dossier est en pre-generation
 *    (annonce/collecte/bloque), `manquant` ou raw au-dela.
 *  - LIVRE (pseudo-pill) : derive de velosLivres / velosQuota.
 *    `na` si dossier pre-logistique (livraison pas encore attendue).
 *
 * P3-A : 'bloque' compte comme pre-generation ET pre-logistique, parce que cote UI
 * on ne peut pas savoir le status d'origine masque dans was=. Choix safe = ne pas
 * afficher faussement "manquant" rouge.
 */

/**
 * Statuts dossier ou les docs generes (Devis/AH) ne sont PAS encore attendus.
 */
export const PRE_GENERATION_STATUSES = new Set(['annonce', 'collecte', 'bloque']);

/**
 * Statuts dossier ou la livraison n est PAS encore attendue.
 */
export const PRE_LOGISTIQUE_STATUSES = new Set([
  'annonce', 'collecte', 'pret_generation', 'attente_signature', 'transmis', 'depot_cee', 'bloque',
]);

/**
 * Derive le status visuel d'un doc admin/genere (pas LIVRE).
 *
 * @param {string | undefined | null} rawStatus - status brut depuis DB (ou 'manquant' fallback)
 * @param {boolean} isGenerated - true pour DEVIS/AH
 * @param {string | undefined} dossierStatus
 * @returns {string} - status visuel (`manquant`, `a_valider`, `valide`, `rejete`, `na`)
 */
export function derivePillStatus(rawStatus, isGenerated, dossierStatus) {
  const raw = rawStatus || 'manquant';
  if (raw !== 'manquant') return raw;
  if (!isGenerated) return 'manquant';
  // Doc genere absent + dossier pre-generation -> na
  return dossierStatus && PRE_GENERATION_STATUSES.has(dossierStatus) ? 'na' : 'manquant';
}

/**
 * Calcule le status visuel de la pseudo-pill LIVRE.
 *
 * @param {number} velosLivres
 * @param {number} velosQuota
 * @param {string | undefined} dossierStatus
 * @returns {string}
 */
export function deriveLivreStatus(velosLivres, velosQuota, dossierStatus) {
  if (velosQuota > 0 && velosLivres >= velosQuota) return 'valide';
  if (velosLivres > 0) return 'a_valider';
  if (dossierStatus && PRE_LOGISTIQUE_STATUSES.has(dossierStatus)) return 'na';
  return 'manquant';
}
